import * as React from "react";

export const IconGoogle = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 21 20" fill="none" {...props}>
    <mask id="mask0_2846_22649" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x={0} y={0} width={21} height={20}>
      <path
        d="M20.1747 8.1814H10.3843V12.0445H15.9742C15.7337 13.294 15.0066 14.3596 13.9023 15.0712C12.9736 15.6716 11.7797 16.0211 10.3843 16.0211C7.68186 16.0211 5.38959 14.2666 4.57049 11.9004C4.36301 11.2989 4.24871 10.6599 4.24871 9.9983C4.24871 9.3367 4.36301 8.6966 4.57049 8.0962C5.38959 5.7311 7.68186 3.9755 10.3843 3.9755C11.9105 3.9755 13.2777 4.4816 14.3561 5.4713L17.3319 2.6057C15.5334 0.9908 13.1857 0 10.3843 0C6.32653 0 2.8132 2.2414 1.10427 5.5076C0.39832 6.8592 0 8.3834 0 9.9994C0 11.6155 0.39832 13.1396 1.10427 14.4913C2.8132 17.7597 6.32653 20 10.3843 20C13.1869 20 15.5464 19.1137 17.2659 17.5861C19.2283 15.8452 20.3561 13.2702 20.3561 10.2275C20.3561 9.5182 20.2936 8.835 20.1747 8.1825V8.1814Z"
        fill="#E94FFF"
      />
    </mask>
    <g mask="url(#mask0_2846_22649)">
      <g filter="url(#filter0_f_2846_22649)">
        <g clipPath="url(#paint0_angular_2846_22649_clip_path)" data-figma-skip-parse="true">
          <g transform="matrix(0.00836294 -0.00805186 0.00836294 0.00805186 10.069 9.79272)">
            <foreignObject x="-1750.01" y="-1750.01" width="3500.02" height="3500.02">
              <div
                style={{
                  background:
                    "conic-gradient(from 90deg,rgba(255, 70, 65, 1) 0deg,rgba(255, 70, 65, 1) 4.14555deg,rgba(49, 134, 255, 1) 39.154deg,rgba(49, 134, 255, 1) 72.0044deg,rgba(0, 165, 183, 1) 96.7463deg,rgba(14, 188, 95, 1) 120.897deg,rgba(14, 188, 95, 1) 154.722deg,rgba(108, 196, 0, 1) 179.136deg,rgba(255, 204, 0, 1) 203.588deg,rgba(255, 211, 20, 1) 226.915deg,rgba(255, 204, 0, 1) 251.688deg,rgba(255, 106, 43, 1) 273.129deg,rgba(253, 70, 65, 1) 289.305deg,rgba(255, 70, 65, 1) 359.593deg,rgba(255, 70, 65, 1) 360deg)",
                  height: "100%",
                  width: "100%",
                  opacity: 1,
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d="M-2.85059 9.79276C-2.85059 2.67596 3.14156 -3.09326 10.5333 -3.09326C17.925 -3.09326 23.917 2.67596 23.917 9.79276C23.917 16.9095 17.925 22.6787 10.5333 22.6787C3.14156 22.6787 -2.8506 16.9095 -2.85059 9.79276Z"
          data-figma-gradient-fill='{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":1.0,"g":0.27450981736183167,"b":0.25490197539329529,"a":1.0},"position":0.011515417136251926},{"color":{"r":0.19215686619281769,"g":0.52549022436141968,"b":1.0,"a":1.0},"position":0.10876122117042542},{"color":{"r":0.19215686619281769,"g":0.52549022436141968,"b":1.0,"a":1.0},"position":0.20001229643821716},{"color":{"r":0.0,"g":0.64705884456634521,"b":0.71764707565307617,"a":1.0},"position":0.26873961091041565},{"color":{"r":0.054901961237192154,"g":0.73725491762161255,"b":0.37254902720451355,"a":1.0},"position":0.33582508563995361},{"color":{"r":0.054901961237192154,"g":0.73725491762161255,"b":0.37254902720451355,"a":1.0},"position":0.42978334426879883},{"color":{"r":0.42528781294822693,"g":0.77231442928314209,"b":0.0,"a":1.0},"position":0.49760133028030396},{"color":{"r":1.0,"g":0.80000001192092896,"b":0.0,"a":1.0},"position":0.56552332639694214},{"color":{"r":1.0,"g":0.82745099067687988,"b":0.078431375324726105,"a":1.0},"position":0.63031959533691406},{"color":{"r":1.0,"g":0.80000001192092896,"b":0.0,"a":1.0},"position":0.69913208484649658},{"color":{"r":1.0,"g":0.41842123866081238,"b":0.16917318105697632,"a":1.0},"position":0.75869029760360718},{"color":{"r":0.99215686321258545,"g":0.27450981736183167,"b":0.25490197539329529,"a":1.0},"position":0.80362409353256226},{"color":{"r":1.0,"g":0.27450981736183167,"b":0.25490197539329529,"a":1.0},"position":0.99887031316757202}],"stopsVar":[{"color":{"r":1.0,"g":0.27450981736183167,"b":0.25490197539329529,"a":1.0},"position":0.011515417136251926},{"color":{"r":0.19215686619281769,"g":0.52549022436141968,"b":1.0,"a":1.0},"position":0.10876122117042542},{"color":{"r":0.19215686619281769,"g":0.52549022436141968,"b":1.0,"a":1.0},"position":0.20001229643821716},{"color":{"r":0.0,"g":0.64705884456634521,"b":0.71764707565307617,"a":1.0},"position":0.26873961091041565},{"color":{"r":0.054901961237192154,"g":0.73725491762161255,"b":0.37254902720451355,"a":1.0},"position":0.33582508563995361},{"color":{"r":0.054901961237192154,"g":0.73725491762161255,"b":0.37254902720451355,"a":1.0},"position":0.42978334426879883},{"color":{"r":0.42528781294822693,"g":0.77231442928314209,"b":0.0,"a":1.0},"position":0.49760133028030396},{"color":{"r":1.0,"g":0.80000001192092896,"b":0.0,"a":1.0},"position":0.56552332639694214},{"color":{"r":1.0,"g":0.82745099067687988,"b":0.078431375324726105,"a":1.0},"position":0.63031959533691406},{"color":{"r":1.0,"g":0.80000001192092896,"b":0.0,"a":1.0},"position":0.69913208484649658},{"color":{"r":1.0,"g":0.41842123866081238,"b":0.16917318105697632,"a":1.0},"position":0.75869029760360718},{"color":{"r":0.99215686321258545,"g":0.27450981736183167,"b":0.25490197539329529,"a":1.0},"position":0.80362409353256226},{"color":{"r":1.0,"g":0.27450981736183167,"b":0.25490197539329529,"a":1.0},"position":0.99887031316757202}],"transform":{"m00":16.725873947143555,"m01":16.725872039794922,"m02":-6.6568660736083984,"m10":-16.103721618652344,"m11":16.103721618652344,"m12":9.7927217483520508},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
        />
      </g>
      <g filter="url(#filter1_f_2846_22649)">
        <path
          d="M9.23126 12.8226C12.0529 14.056 14.8867 13.9003 15.5606 12.4748C16.2346 11.0492 14.4936 8.89373 11.672 7.66031C8.85037 6.42689 6.01661 6.58263 5.34262 8.00816C4.66862 9.43369 6.40963 11.5892 9.23126 12.8226Z"
          fill="#3186FF"
        />
      </g>
      <g filter="url(#filter2_f_2846_22649)">
        <path
          d="M24.288 11.3092C28.5609 11.3092 32.0248 9.92417 32.0248 8.21564C32.0248 6.50711 28.5609 5.12207 24.288 5.12207C20.0151 5.12207 16.5513 6.50711 16.5513 8.21564C16.5513 9.92417 20.0151 11.3092 24.288 11.3092Z"
          fill="#3186FF"
        />
      </g>
      <g filter="url(#filter3_f_2846_22649)">
        <path
          d="M15.8851 8.59765C20.1403 8.59765 23.5899 7.53296 23.5899 6.2196C23.5899 4.90624 20.1403 3.84155 15.8851 3.84155C11.6298 3.84155 8.18018 4.90624 8.18018 6.2196C8.18018 7.53296 11.6298 8.59765 15.8851 8.59765Z"
          fill="#FF4641"
        />
      </g>
      <g filter="url(#filter4_f_2846_22649)">
        <path
          d="M20.324 5.30493C24.5793 5.30493 28.0289 4.24024 28.0289 2.92688C28.0289 1.61352 24.5793 0.548828 20.324 0.548828C16.0687 0.548828 12.6191 1.61352 12.6191 2.92688C12.6191 4.24024 16.0687 5.30493 20.324 5.30493Z"
          fill="#FF5B8B"
        />
      </g>
      <g filter="url(#filter5_f_2846_22649)">
        <path
          d="M15.0607 12.9878C19.9464 12.9878 23.907 11.5955 23.907 9.87807C23.907 8.1606 19.9464 6.76831 15.0607 6.76831C10.175 6.76831 6.21436 8.1606 6.21436 9.87807C6.21436 11.5955 10.175 12.9878 15.0607 12.9878Z"
          fill="#3186FF"
        />
      </g>
      <g filter="url(#filter6_f_2846_22649)">
        <path
          d="M16.9777 6.1064C19.2653 4.90415 20.5887 2.99529 19.9336 1.84284C19.2785 0.690387 16.893 0.730755 14.6054 1.933C12.3178 3.13525 10.9944 5.04411 11.6495 6.19656C12.3046 7.34901 14.6901 7.30864 16.9777 6.1064Z"
          fill="#FF4641"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_f_2846_22649"
        x="-4.85059"
        y="-5.09326"
        width="30.7676"
        height="29.772"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation={1} result="effect1_foregroundBlur_2846_22649" />
      </filter>
      <clipPath id="paint0_angular_2846_22649_clip_path">
        <path d="M-2.85059 9.79276C-2.85059 2.67596 3.14156 -3.09326 10.5333 -3.09326C17.925 -3.09326 23.917 2.67596 23.917 9.79276C23.917 16.9095 17.925 22.6787 10.5333 22.6787C3.14156 22.6787 -2.8506 16.9095 -2.85059 9.79276Z" />
      </clipPath>
      <filter
        id="filter1_f_2846_22649"
        x="3.19775"
        y="4.82812"
        width="14.5078"
        height="10.8267"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation={1} result="effect1_foregroundBlur_2846_22649" />
      </filter>
      <filter
        id="filter2_f_2846_22649"
        x="14.5513"
        y="3.12207"
        width="19.4736"
        height="10.1873"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation={1} result="effect1_foregroundBlur_2846_22649" />
      </filter>
      <filter
        id="filter3_f_2846_22649"
        x="6.18018"
        y="1.84155"
        width="19.4097"
        height="8.7561"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation={1} result="effect1_foregroundBlur_2846_22649" />
      </filter>
      <filter
        id="filter4_f_2846_22649"
        x="10.6191"
        y="-1.45117"
        width="19.4097"
        height="8.7561"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation={1} result="effect1_foregroundBlur_2846_22649" />
      </filter>
      <filter
        id="filter5_f_2846_22649"
        x="4.21436"
        y="4.76831"
        width="21.6929"
        height="10.2195"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation={1} result="effect1_foregroundBlur_2846_22649" />
      </filter>
      <filter
        id="filter6_f_2846_22649"
        x="9.48193"
        y="-0.99585"
        width="12.6191"
        height="10.031"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation={1} result="effect1_foregroundBlur_2846_22649" />
      </filter>
    </defs>
  </svg>
);
